import { useContext } from 'react';
import { ToastContext } from '@/contexts/ToastContext';
import { invariant } from '@/utils/invariant';

export function useToast() {
  return invariant(useContext(ToastContext), 'useToast must be used inside <ToastProvider>.');
}
